<template>
  <section>
    <highcharts ref="areaLine" class="hc" :options="options"></highcharts>
  </section>
</template>
<script>
export default {
  name: 'AreaLine',
  props: {
    chartOptions: Object
  },
  computed: {
    options() {
      let _options = {
        title: {
          text: this.chartOptions?.title
        },
        subtitle: {
          text: this.chartOptions?.subtitle
        },
        xAxis: this.chartOptions?.xAxis
          ? this.chartOptions.xAxis
          : {
              type: 'string',
              allowDecimals: false,
              title: {
                text: 'Month'
              },
              labels: {
                format: '{value}',
                formatter: function () {
                  var label = this.value + 1
                  return label
                }
              }
            },
        yAxis: this.chartOptions?.yAxis
          ? this.chartOptions.yAxis
          : {
              title: {
                text: this.chartOptions?.ylabel
              },
              min: 0
            },
        tooltip: {
          crosshairs: true,
          shared: true
        },
        // Define the data points. All series have a dummy year
        // of 1970/71 in order to be compared on the same x axis. Note
        // that in JavaScript, months start at 0 for January, 1 for February etc.
        series: this.chartOptions?.series,
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 300
              },
              chartOptions: {
                plotOptions: {
                  series: {
                    marker: {
                      radius: 2.5
                    }
                  }
                }
              }
            }
          ]
        }
      }
      return _options
    }
  }
}
</script>
<style lang="scss" scoped></style>
